export const NavBarHeight = "60px"
export const QuestionSpacing = "8rem"
